// extracted by mini-css-extract-plugin
export default {"spinner":"InlineSpinner_spinner__jh2fL","inline-spin":"InlineSpinner_inline-spin__lGHMT"};